import FinAut from "Static/svg/autorisert_robotraadgiver_privatmarked.svg";
import styled from "styled-components";

export const Wrapper = styled.div`
  align-items: start;
  background-color: inherit;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  margin: ${({ theme }) => theme.spacing.sm} auto;
  padding: 0 ${({ theme }) => theme.spacing.sm};
  width: 100%;

  @media screen and (min-width: 768px) {
    max-width: 1176px;
    padding: 0 32px;
  }
`;

export const FinAutIcon = styled(FinAut)`
  align-items: center;
  box-sizing: border-box;
  display: block;
  margin-right: 20px;
  margin-top: 10px;
  width: 110px;
`;
